module.exports = __webpack_public_path__ + "img/emoji_liwu.fc4b2cbf.png";